document.querySelectorAll('.inline-form--search-autosuggest').forEach(($dropdown) => {
  const input = $dropdown.querySelector('.input--autosuggest');
  const autocomplete = document.querySelector('.lfk__channels__autocomplete');

  function handleInput() {
    if (autocomplete) {
      input.classList.add('active-autosuggest');
    }
  }

  input.oninput = handleInput;
});

document.querySelectorAll('.inline-form__search--1').forEach(($inlineForm) => {
  $inlineForm.addEventListener('submit', () => {
    if (!document.body.classList.contains('deactivate--search')) {
      const input = $inlineForm.querySelector('.input');
      const replaceVal = input.value.replace(/['"]/g, '');
      const quoteStart = '"';
      const quoteEnd = '"';
      const updateVal = quoteStart.concat(replaceVal, quoteEnd);
      input.value = updateVal;
      input.setAttribute('value', updateVal);
    }
  });
});

document.querySelectorAll('.inline-form__search--2').forEach(($inlineForm) => {
  $inlineForm.addEventListener('submit', () => {
    if (!document.body.classList.contains('deactivate--search')) {
      const input = $inlineForm.querySelector('.input');
      const replaceVal = input.value.replace(/['"]/g, '');
      const quoteStart = '"';
      const quoteEnd = '"';
      const updateVal = quoteStart.concat(replaceVal, quoteEnd);
      input.value = updateVal;
      input.setAttribute('value', updateVal);
    }
  });
});
